export const openFoodItem = () => {

    return {
        type: 'OPEN_FOOD_ITEM_MODAL',
    };
};

export const closeFoodItem = () => {

    return {
        type: 'CLOSE_FOOD_ITEM_MODAL',
    };
};

export const openPizza = () => {

    return {
        type: 'OPEN_PIZZA_MODAL',
    };
};

export const closePizza = () => {

    return {
        type: 'CLOSE_PIZZA_MODAL',
    };
};

export const openCustomPizza = () => {

    return {
        type: 'OPEN_CUSTOM_PIZZA_MODAL',
    };
};

export const closeCustomPizza = () => {

    return {
        type: 'CLOSE_CUSTOM_PIZZA_MODAL',
    };
};


export const openSpecial = () => {

    return {
        type: 'OPEN_SPECIAL_MODAL',
    };
};

export const closeSpecial = () => {

    return {
        type: 'CLOSE_SPECIAL_MODAL',
    };
};

export const openCart = () => {

    return {
        type: 'OPEN_CART_MODAL',
    };
};

export const closeCart = () => {

    return {
        type: 'CLOSE_CART_MODAL',
    };
};

export const openCartDelivery = () => {

    return {
        type: 'OPEN_CART_DELIVERY_MODAL',
    };
};

export const closeCartDelivery = () => {

    return {
        type: 'CLOSE_CART_DELIVERY_MODAL',
    };
};

export const resetModals = () => {

    return {
        type: 'RESET_MODALS',
    };
};